import React from 'react';

const NexusHero = () => {
  return (
    <section className="bg-white pt-40 pb-24 dark:bg-zinc-950">
      <div className="mx-auto max-w-4xl px-4">
        <p className="text-sm font-semibold uppercase tracking-[0.35em] text-zinc-500 dark:text-zinc-400">
          AI Agents
        </p>
        <h1 className="mt-6 text-[2.65rem] leading-[1.1] tracking-[-1.5px] text-zinc-900 dark:text-zinc-50 md:text-[4.2rem] md:tracking-[-3px]">
          The gold rush is real. Most teams are digging in the wrong dirt.
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-zinc-600 dark:text-zinc-300">
          The market is noisy, timelines are brutal, and production wins are rare. We’ve been shipping agent ecosystems daily for two years—
          this is the shortcut past the hype.
        </p>

        <div className="mt-10 space-y-4 text-zinc-600 dark:text-zinc-300">
          <p><span className="font-semibold text-zinc-900 dark:text-zinc-100">We live this every day.</span> Dedicated R&amp;D crews, component libraries, and agent registries built from scars—not slide decks.</p>
          <p><span className="font-semibold text-zinc-900 dark:text-zinc-100">Winners with compounding flywheels will eat the laggards.</span> The next few years decide who has leverage.</p>
          <p><span className="font-semibold text-zinc-900 dark:text-zinc-100">Anything can be automated.</span> A production agent costs $15–20K when you start with the right patterns.</p>
        </div>
      </div>
    </section>
  );
};

export { NexusHero };
